var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.11836 19.1184C9.60528 19.6053 10.3947 19.6053 10.8816 19.1184C11.3683 18.6317 11.3686 17.8429 10.8824 17.3559L4.7875 11.25L18.75 11.25C19.4404 11.25 20 10.6904 20 10C20 9.30965 19.4404 8.75 18.75 8.75L4.7875 8.75L10.8824 2.64415C11.3686 2.1571 11.3683 1.36826 10.8816 0.881648C10.3947 0.39473 9.60527 0.394731 9.11836 0.881648L1.03312e-06 10L9.11836 19.1184Z"}));
}

ArrowBack.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
